// extracted by mini-css-extract-plugin
export var container = "_99-0";
export var icon = "_99-1";
export var text = "_99-2";